import { Search, PenTool, Calculator, CalendarCheck, ShoppingCart, HardHat, Radar, Wallet, KeyRound, Wrench } from "lucide-react";
import { Reveal, SectionHeading } from "@/components/Reveal";
import { JOURNEY_STEPS } from "@/data/content";
import { cn } from "@/lib/utils";

const ICONS = { Search, PenTool, Calculator, CalendarCheck, ShoppingCart, HardHat, Radar, Wallet, KeyRound, Wrench };

export const CustomerJourney = () => (
    <section id="journey" data-testid="customer-journey-section" className="relative overflow-hidden bg-omsivo-paper py-24 lg:py-32">
        <div className="mx-auto max-w-[1440px] px-4 sm:px-6 lg:px-10">
            <SectionHeading
                id="journey-heading"
                overline="The OMSIVO Customer Journey"
                title={<>Ten steps. <span className="text-flame-dark">Zero guesswork.</span></>}
                description="From discovering OMSIVO to maintaining your finished building — every stage of the journey is designed to be visible and understandable."
            />
            <div className="mt-14 grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-5" data-testid="journey-grid">
                {JOURNEY_STEPS.map((s, i) => {
                    const Icon = ICONS[s.icon];
                    return (
                        <Reveal key={s.key} delay={0.05 * (i % 5)}>
                            <div
                                className={cn(
                                    "lift-card relative flex h-full flex-col rounded-2xl border p-6",
                                    s.app ? "border-flame bg-omsivo-navy text-white shadow-xl shadow-omsivo-navy/20" : "border-omsivo-navy/10 bg-white"
                                )}
                                data-testid={`journey-step-${s.key.toLowerCase()}`}
                            >
                                <div className="flex items-center justify-between">
                                    <div className={cn("flex h-11 w-11 items-center justify-center rounded-xl",
                                        s.app ? "bg-flame text-white" : "bg-omsivo-navy/5 text-omsivo-blue")}>
                                        <Icon className="h-5 w-5" />
                                    </div>
                                    <span className={cn("font-mono text-[10px]", s.app ? "text-flame" : "text-slate-300")}>
                                        {String(i + 1).padStart(2, "0")}
                                    </span>
                                </div>
                                <h3 className={cn("mt-5 font-display text-sm font-extrabold uppercase tracking-[0.1em]", s.app ? "text-white" : "text-omsivo-navy")}>
                                    {s.key}
                                </h3>
                                {s.app && (
                                    <p className="mt-2 font-mono text-[9px] uppercase leading-relaxed tracking-[0.16em] text-flame">
                                        Via OMSIVO Customer App
                                    </p>
                                )}
                            </div>
                        </Reveal>
                    );
                })}
            </div>
            <Reveal delay={0.2}>
                <p className="mt-8 max-w-2xl text-xs leading-relaxed text-slate-500">
                    Detailed cost estimation and ongoing project management run on the OMSIVO Customer App — currently marked COMING SOON.
                </p>
            </Reveal>
        </div>
    </section>
);
